/** Textos y utilidades de Ventas. Todo el texto de la pantalla en español, aquí. */

export const ETAPAS: { id: number; name: string }[] = [
	{ id: 1, name: "Pre-Inscripción" }, { id: 2, name: "Matriculado" }, { id: 3, name: "Retirado" }, { id: 4, name: "Graduado" }
];

/*
	El riel de vistas. Son los filtros que Esteban pidió (2026-09-19), agrupados.
	La "alerta" pinta el conteo en oro (lo que ya se atrasó).
*/
export const VISTAS: { grupo: string; items: { key: string; label: string; alerta?: boolean; fuerte?: boolean }[] }[] = [
	{
		grupo: "Entradas nuevas", items: [
			{ key: "sin_atender", label: "Sin atender", fuerte: true },
			{ key: "creaciones_hoy", label: "Creaciones hoy" },
			{ key: "creaciones_ayer", label: "Ayer" },
			{ key: "creaciones_semana", label: "Esta semana" },
			{ key: "creaciones_mes", label: "Este mes" },
			{ key: "sin_movimiento", label: "Sin movimiento aún", alerta: true },
		]
	},
	{
		grupo: "Seguimientos", items: [
			{ key: "vencidas", label: "Vencidos", alerta: true },
			{ key: "hoy", label: "Hoy" },
			{ key: "manana", label: "Mañana" },
			{ key: "semana", label: "Resto de la semana" },
		]
	},
	{
		grupo: "Sin nota hace", items: [
			{ key: "sin_nota_5", label: "5 días o más" },
			{ key: "sin_nota_10", label: "10 días o más" },
			{ key: "sin_nota_30", label: "30 días o más", alerta: true },
		]
	},
	{
		grupo: "Status", items: [
			{ key: "promesas", label: "Promesas" },
			{ key: "interesados", label: "Interesados" },
			{ key: "potencial", label: "Potencial · Prospecto" },
		]
	},
	{
		grupo: "Alertas", items: [
			{ key: "quitaron_seguimiento", label: "Le quitaron seguimiento", alerta: true },
			{ key: "nuevo_3_notas", label: "Nuevo cliente con 3+ notas", alerta: true },
		]
	},
];

/* El riel cambia con la Etapa (lienzo): Matriculado ve oportunidades y retención; Retirado, reingreso. */
export const VISTAS_MATRICULADO: typeof VISTAS = [
	{
		grupo: "Oportunidades", items: [
			{ key: "califican_promo", label: "Califican a promo", fuerte: true },
			{ key: "abonos_kit", label: "Abonos sin liquidar" },
			{ key: "sin_producto", label: "Sin producto" },
			{ key: "terminan_modulo", label: "Terminan módulo < 30 d" },
			{ key: "inscritos_recientes", label: "Inscritos recientes" },
		]
	},
	{
		grupo: "Retención", items: [
			{ key: "mensualidad_vencida", label: "Mensualidad vencida", alerta: true },
			{ key: "faltas_3", label: "3+ faltas seguidas", alerta: true },
			{ key: "riesgo_retiro", label: "Riesgo de retiro", alerta: true },
		]
	},
	{ grupo: "Actividades", items: [{ key: "vencidas", label: "Vencidas", alerta: true }, { key: "hoy", label: "Hoy" }, { key: "manana", label: "Mañana" }, { key: "semana", label: "Resto de la semana" }] },
	{ grupo: "Status", items: [{ key: "recontacto", label: "Recontactó" }, { key: "promesas", label: "Promesa" }, { key: "sin_gestion", label: "Sin gestión activa" }] },
];
export const VISTAS_RETIRADO: typeof VISTAS = [
	{
		grupo: "Reingreso", items: [
			{ key: "retiro_1_6", label: "Se retiraron hace 1–6 meses", fuerte: true },
			{ key: "retiro_6_12", label: "6–12 meses" },
			{ key: "retiro_12", label: "Más de un año" },
			{ key: "retiro_sin_saldo", label: "Sin saldo pendiente" },
			{ key: "retiro_con_saldo", label: "Con saldo", alerta: true },
		]
	},
	{
		grupo: "Motivo de retiro", items: [
			{ key: "retiro_economico", label: "Económico" },
			{ key: "retiro_trabajo", label: "Trabajo · horario" },
			{ key: "retiro_salud", label: "Salud · viaje" },
			{ key: "retiro_sin_motivo", label: "Sin motivo registrado" },
		]
	},
	{ grupo: "Actividades", items: [{ key: "vencidas", label: "Vencidas", alerta: true }, { key: "hoy", label: "Hoy" }, { key: "manana", label: "Mañana" }] },
	{ grupo: "Status", items: [{ key: "recontacto", label: "Recontactó" }, { key: "promesas", label: "Promesa" }] },
];
export const VISTAS_GRADUADO: typeof VISTAS = [
	{ grupo: "Actividades", items: [{ key: "vencidas", label: "Vencidas", alerta: true }, { key: "hoy", label: "Hoy" }, { key: "manana", label: "Mañana" }] },
	{ grupo: "Status", items: [{ key: "recontacto", label: "Recontactó" }, { key: "promesas", label: "Promesa" }, { key: "sin_gestion", label: "Sin gestión activa" }] },
];
export const vistasDeEtapa = (etapa: number): typeof VISTAS => etapa === 2 ? VISTAS_MATRICULADO : etapa === 3 ? VISTAS_RETIRADO : etapa === 4 ? VISTAS_GRADUADO : VISTAS;

export const TITULO_VISTA = (key: string | null): string => {
	if (!key) return "Toda la cartera";
	for (const v of [VISTAS, VISTAS_MATRICULADO, VISTAS_RETIRADO, VISTAS_GRADUADO]) for (const g of v) for (const i of g.items) if (i.key === key) return (g.grupo === "Sin nota hace" ? "Sin nota hace " : "") + i.label;
	return "Toda la cartera";
};

/** Dinero como lo escribe el equipo: "L 1,500.00" · "$ 2,000.00". */
export const dinero = (v: number | null | undefined, simbolo = ""): string =>
	v === null || v === undefined ? "—" : (simbolo ? simbolo + " " : "") + Number(v).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const SIMBOLO_PLANTEL: { [k: number]: string } = { 1: "$", 2: "$", 3: "L", 4: "L", 5: "L", 7: "US$" };

export const statusClase = (statusId: number): string =>
	({ 1: "nuevo", 2: "recontacto", 3: "interesado", 4: "promesa" } as any)[statusId] || "";

export const etapaClase = (etapaId: number): string =>
	({ 1: "etapa1", 2: "matriculado", 3: "retirado", 4: "graduado" } as any)[etapaId] || "";

export const KIND_LABEL: { [k: string]: string } = {
	nota: "Nota", llamada: "Llamada", whatsapp: "WhatsApp", tarea: "Tarea", cambio: "Cambio",
	asignacion: "Asignación", promo: "Promo", sistema: "Sistema"
};

export const KIND_FILTROS: { key: string; label: string; kinds: string[] }[] = [
	{ key: "todo", label: "Todo", kinds: [] },
	{ key: "notas", label: "Notas", kinds: ["nota"] },
	{ key: "llamadas", label: "Llamadas", kinds: ["llamada"] },
	{ key: "whatsapp", label: "WhatsApp", kinds: ["whatsapp"] },
	{ key: "tareas", label: "Tareas", kinds: ["tarea"] },
	{ key: "movimientos", label: "Movimientos", kinds: ["cambio", "asignacion"] },
];

export const ORIGEN_LABEL: { [k: string]: string } = { zoho: "Zoho", wapp: "WAPP", router: "Bot", audit: "Zoho", vozmia: "VozMia" };

/** El servidor guarda UTC ("2026-09-24 19:06:06") → Date. */
const parse = (v: string | null | undefined): Date | null => {
	if (!v) return null;
	const d = new Date(v.replace(" ", "T") + (/[zZ]|[+-]\d\d:?\d\d$/.test(v) ? "" : "Z"));
	return isNaN(d.getTime()) ? null : d;
};

/*
	Se muestra siempre en hora de Ciudad de México (= Honduras): UTC-6 todo el año, sin horario de verano desde 2022.
	Así una supervisora que abre WAPP de viaje ve lo mismo que la asesora en el plantel.
*/
const MX_MS = 6 * 3600000;
const mx = (d: Date) => {
	const t = new Date(d.getTime() - MX_MS);
	return { y: t.getUTCFullYear(), m: t.getUTCMonth(), d: t.getUTCDate(), h: t.getUTCHours(), mi: t.getUTCMinutes(),
		dia: Math.floor((d.getTime() - MX_MS) / 86400000) };
};

const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
const hora12 = (h: number, mi: number) => `${h % 12 || 12}:${String(mi).padStart(2, "0")} ${h < 12 ? "am" : "pm"}`;

/** Fecha corta como en el resto de WAPP: "hoy 11:04", "ayer 16:22", "12 sep", "mar 2019". */
export const cuando = (v: string | null | undefined): string => {
	const d = parse(v);
	if (!d) return "—";
	const f = mx(d), hoy = mx(new Date());
	const diff = hoy.dia - f.dia;
	if (diff === 0) return "hoy " + hora12(f.h, f.mi);
	if (diff === 1) return "ayer " + hora12(f.h, f.mi);
	if (diff === -1) return "mañana " + hora12(f.h, f.mi);
	if (f.y === hoy.y) return `${f.d} ${MESES[f.m]}`;
	return `${MESES[f.m]} ${f.y}`;
};

export const fechaLarga = (v: string | null | undefined): string => {
	const d = parse(v);
	if (!d) return "—";
	const f = mx(d);
	return `${f.d} ${MESES[f.m]} ${f.y}, ${hora12(f.h, f.mi)}`;
};

/** Fecha sin hora de Zoho ("2026-09-24", vencimiento de tarea): se muestra tal cual, sin mover de zona. */
export const fechaDia = (v: string | null | undefined): string => {
	const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v || "");
	return m ? `${Number(m[3])} ${MESES[Number(m[2]) - 1]} ${m[1]}` : (v || "—");
};

export const anio = (v: string | null | undefined): number | null => {
	const d = parse(v);
	return d ? mx(d).y : null;
};

export const esteAnio = (): number => mx(new Date()).y;

export const vencido = (v: string | null | undefined): boolean => {
	const d = parse(v);
	return !!d && d.getTime() < Date.now();
};

/** Valor de <input type="datetime-local"> (hora de México) → ISO UTC para el servidor. */
export const localMxAIso = (v: string): string => new Date(new Date(v + ":00Z").getTime() + MX_MS).toISOString();

export const nombreCompleto = (p: { first_name?: string | null; last_name?: string | null }): string =>
	[p.first_name, p.last_name].filter(Boolean).join(" ").trim() || "Sin nombre";

export const errorTexto = (e: any): string =>
	e?.response?.data?.message || e?.message || "No se pudo completar. Intenta otra vez.";

/** Etiqueta del día para separar la conversación: "hoy", "ayer", "martes 22 sep", "12 mar 2024". */
const DIAS = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
export const diaEtiqueta = (v: string | null | undefined): string => {
	const d = parse(v);
	if (!d) return "";
	const f = mx(d), hoy = mx(new Date());
	const diff = hoy.dia - f.dia;
	if (diff === 0) return "hoy";
	if (diff === 1) return "ayer";
	const dow = DIAS[new Date(Date.UTC(f.y, f.m, f.d)).getUTCDay()];
	if (diff > 1 && diff < 7) return `${dow} ${f.d} ${MESES[f.m]}`;
	return f.y === hoy.y ? `${f.d} ${MESES[f.m]}` : `${f.d} ${MESES[f.m]} ${f.y}`;
};
export const diaClave = (v: string | null | undefined): number => { const d = parse(v); return d ? mx(d).dia : 0; };

/** Solo la hora, en hora de México: "9:31 am". */
export const hora = (v: string | null | undefined): string => {
	const d = parse(v);
	if (!d) return "";
	const f = mx(d);
	return hora12(f.h, f.mi);
};

/** Cuánto falta para que cierre la ventana de 24 h: "6 h 12 min". */
export const faltan = (v: string | null | undefined): string => {
	const d = parse(v);
	if (!d) return "";
	const min = Math.max(0, Math.round((d.getTime() - Date.now()) / 60000));
	return min >= 60 ? `${Math.floor(min / 60)} h ${min % 60} min` : `${min} min`;
};

/** "kind|direction|texto" de la bandeja → texto corto como en el mockup. */
export const ultimoMensaje = (v: string | null | undefined): string => {
	if (!v) return "";
	const [kind, dir, ...rest] = v.split("|");
	const t = rest.join("|").replace(/\s+/g, " ").trim();
	if (kind === "whatsapp") return dir === "out" ? "Tú: " + t : t;
	if (kind === "nota") return "Nota: " + t;
	if (kind === "llamada") return t;
	return t;
};

export const RESULTADOS_LLAMADA: { key: string; label: string }[] = [
	{ key: "contesto", label: "Contestó" }, { key: "no_contesto", label: "No contestó" }, { key: "buzon", label: "Buzón" },
	{ key: "ocupado", label: "Ocupado" }, { key: "cortada", label: "Se cortó" }, { key: "equivocado", label: "Número equivocado" },
];

export const GENEROS: { id: number; name: string }[] = [{ id: 1, name: "Hombre" }, { id: 2, name: "Mujer" }];

/** Quita acentos y minúsculas, para empatar "Repostería" con "reposteria / pasteleria". */
export const plano = (s: string | null | undefined): string =>
	(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

/* Barra de arriba (lienzo): Objetivo y Día · Mañana · Tarde. El objetivo es la regla de WAPP que lo define
   (promo = le aplica una, kit = debe o no tiene, retención = vencida o faltas) o una gestión abierta con ese objetivo. */
export const OBJETIVOS_BARRA: { key: string; label: string; etapas: number[] }[] = [
	{ key: "inscripcion", label: "Inscripción", etapas: [1] },
	{ key: "promo", label: "Promo", etapas: [2] },
	{ key: "kit", label: "Kit", etapas: [2] },
	{ key: "mas_cursos", label: "Más cursos", etapas: [2, 4] },
	{ key: "retencion", label: "Retención", etapas: [2] },
	{ key: "reinscripcion", label: "Reinscripción", etapas: [3] },
];
export const GESTION_RESULTADOS: { key: string; label: string }[] = [
	{ key: "logrado", label: "Lo logró (pagó / se inscribió)" }, { key: "no_interesa", label: "No le interesa" },
	{ key: "no_contesta", label: "No contesta" }, { key: "despues", label: "Lo deja para después" }, { key: "otro", label: "Otro" },
];

/** La línea de la fila de Matriculado: "pagó 4 de 10 · PROMO 10x2 · KIT pendiente". */
export const resumenWapp = (w: { pagadas: number | null; meses: number | null; vencidas: number; promo: string | null; kit: string | null } | null | undefined): string => {
	if (!w) return "";
	const partes: string[] = [];
	if (w.meses) partes.push(`pagó ${w.pagadas ?? 0} de ${w.meses}`);
	if (w.vencidas > 0) partes.push(`${w.vencidas} vencida${w.vencidas === 1 ? "" : "s"}`);
	if (w.promo) partes.push("PROMO " + w.promo);
	if (w.kit) partes.push(w.kit === "abono" ? "KIT abono sin liquidar" : "KIT pendiente");
	return partes.join(" · ");
};
